import { defineFakeRoute } from "vite-plugin-fake-server/client";

export default defineFakeRoute([
  {
    url: "/mock/api/db/tables",
    method: "get",
    response: () => {
      return {
        code: 20000,
        tables: ["nc__raw_collection", "nc__scene_index"]
      };
    }
  },
  {
    url: "/mock/api/db/table_rows",
    method: "get",
    response: request => {
      const page = request.query.page;
      const pageSize = request.query.pageSize;
      const mockRows = Array.from({ length: pageSize }, (_, index) => ({
        id: (index + 1).toString(),
        rcid: `rcid: ${index + 1}`,
        rcstatus: `rcstatus: ${index + 1}`,
        feed_id: `feed_id: ${index + 1}`,
        std_title: `std_title: ${index + 1}`,
        std_content: `page ${page}: hey ${index + 1}`
      }));
      return {
        code: 20000,
        rows: mockRows,
        columns: ["id", "rcid", "rcstatus", "feed_id", "std_content"],
        total: pageSize * 10
      };
    }
  }
]);
